<template>
  <div class="tile is-parent">
    <article class="module-menu">
      <module-menu :type="0"></module-menu>
    </article>
    <article class="tile is-child">
      <!--0热区,1横滑,2轮播,3系统-全民搭配师,4系统-猜搭配,5系统-视频学穿搭,6系统-干货笔记-->
      <template v-if='currentFashionMenu.moduleType == 0'>
        <hot-map></hot-map>
      </template>
      <template v-if='currentFashionMenu.moduleType == 1'>
        <sideslip></sideslip>
      </template>
      <template v-if='currentFashionMenu.moduleType == 2'>
        <carousel :module-id="currentFashionMenu.moduleId"></carousel>
      </template>
      <template v-if ='currentFashionMenu.moduleType != 0 && currentFashionMenu.moduleType != 1 && currentFashionMenu.moduleType != 2'>
        <system-module></system-module>
      </template>
    </article>
  </div>
</template>

<script type="text/babel">
  import {mapState, mapActions} from 'vuex';
  import carousel from './carousel/carousel';
  import moduleMenu from '../fashionModuleMenu/main'
  import hotMap from './hotMap/main'
  import sideslip from './sideslip/main';
  import systemModule from './systemModule/main'

   export default {
    computed:{
      ...mapState({
        currentFashionMenu: state => state.currentFashionMenu
      })
    },
    components:{
      moduleMenu, hotMap, carousel, sideslip, systemModule
    },
  }
</script>

<style lang="less" scoped>
  .module-menu {
    width: 200px;
    min-width: 200px;
    margin-right: 20px;
  }
</style>
